
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { TextAreaStyle, TextAlignKinds } from "../../../../../../base/domain/drawing";
import { StandardOption } from "../../../../../../base/components/system/selectors/mixins";
import {
  ITextStylePropertyEditable, instanceOfITextStylePropertyEditable,
  instanceOfITextStyleSelectable
} from "../../../../../domain/editableFormat/properties";

@Component
export default class TextStylePropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: ITextStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITextStylePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTextStyleEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITextStylePropertyEditable(s) && s.textStyle().isEditable(), false);
  }

  get isTextStyleFontColorEditable(): boolean {
    return this.isTextStyleEditable
        && this.readPropertyOrDefault(s => !instanceOfITextStyleSelectable(s) || !s.isFontColorSelectable(), false);
  }

  get isTextStylePaintColorEditable(): boolean {
    return this.isTextStyleEditable
        && this.readPropertyOrDefault(s => !instanceOfITextStyleSelectable(s) || !s.isPaintColorSelectable(), false);
  }

  get textStyle(): TextAreaStyle {
    return this.readPropertyOrDefault(s => TextAreaStyle.from(s.textStyle().getValue()), new TextAreaStyle());
  }

  set textStyle(value: TextAreaStyle) {
    this.writePropertyWhenValid(s => s.textStyle().setValue(TextAreaStyle.to(value)));
  }

  get alignmentKinds(): TextAlignKinds[] {
    return this.readPropertyOrDefault(s => s.getSelectableAlignmentKinds(), []);
  }

  get alignmentOptions(): StandardOption<TextAlignKinds>[] {
    return Enumerable.from(TextStylePropertyEditableMixin._alignmentOptions)
      .where(o => 0 <= this.alignmentKinds.indexOf(o.value))
      .toArray();
  }

  private static readonly _alignmentOptions: StandardOption<TextAlignKinds>[] = [
    new StandardOption("左寄/上寄", TextAlignKinds.TopLeft),
    new StandardOption("中央/上寄", TextAlignKinds.TopCenter),
    new StandardOption("右寄/上寄", TextAlignKinds.TopRight),
    new StandardOption("左寄/中央", TextAlignKinds.MiddleLeft),
    new StandardOption("中央/中央", TextAlignKinds.MiddleCenter),
    new StandardOption("右寄/中央", TextAlignKinds.MiddleRight),
    new StandardOption("左寄/下寄", TextAlignKinds.BottomLeft),
    new StandardOption("中央/下寄", TextAlignKinds.BottomCenter),
    new StandardOption("右寄/下寄", TextAlignKinds.BottomRight),
  ];
}
